import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'align-center', 'AlignCenter', [["path",{"d":"M4 6l16 0"}],["path",{"d":"M8 12l8 0"}],["path",{"d":"M6 18l12 0"}]]);